/**
 * Dineo Design System - Component Style Overrides
 *
 * MUI 7 component customizations: rounded corners, consistent
 * spacing, and restaurant-UI-friendly touch targets.
 */

// Shared focus-visible style for keyboard accessibility
const focusVisible = {
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'var(--mui-palette-primary-main, #305C37)',
    outlineOffset: '2px',
  },
};

export const components = {
  MuiButtonBase: {
    styleOverrides: {
      root: focusVisible,
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        textTransform: 'none',
        fontWeight: 600,
        ...focusVisible,
      },
      sizeSmall: {
        height: 36,
        padding: '0 16px',
      },
      sizeMedium: {
        height: 44,
        padding: '0 20px',
      },
      sizeLarge: {
        height: 52,
        padding: '0 28px',
      },
    },
  },

  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        overflow: 'hidden',
      },
    },
  },

  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 20,
      },
    },
    defaultProps: {
      slotProps: {
        backdrop: {
          sx: {
            backdropFilter: 'blur(4px)',
          },
        },
      },
    },
  },

  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 10,
        },
      },
    },
  },

  MuiInputLabel: {
    styleOverrides: {
      outlined: {
        '&.MuiInputLabel-shrink': {
          transform: 'translate(14px, -9px)',
          fontSize: '0.75rem',
          backgroundColor: 'var(--mui-palette-background-paper, #fff)',
          paddingLeft: 6,
          paddingRight: 6,
        },
      },
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        '&:not(.MuiInputBase-multiline)': {
          height: 48,
        },
      },
    },
  },

  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 999,
        height: 'auto',
        ...focusVisible,
      },
    },
  },

  MuiLink: {
    styleOverrides: {
      root: focusVisible,
    },
  },

  MuiIconButton: {
    styleOverrides: {
      root: focusVisible,
    },
  },

  MuiTableRow: {
    styleOverrides: {
      root: {
        height: 52,
        '&:last-child td, &:last-child th': {
          borderBottom: 0,
        },
      },
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 16,
      },
    },
  },
};
